import React, { useState } from 'react';
import { Row, Col, Card, Tabs } from 'antd';
import {
  UserOutlined,
  CalendarOutlined,
  MedicineBoxOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import StatCard from './StatCard';
import PatientList from './PatientList';
import AppointmentList from './AppointmentList';
import MedicalRecords from './MedicalRecords';
import Billing from './Billing';
import { theme } from '../utils/theme';

const { TabPane } = Tabs;

const Dashboard = ({ patients, appointments }) => {
  const [activeTab, setActiveTab] = useState('1');

  return (
    <div style={{ padding: '24px' }}>
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} md={6}>
          <StatCard 
            icon={<UserOutlined style={{ color: theme.primaryBlue, fontSize: '24px' }} />}
            title="Total Patients" 
            value="2,458" 
            trend="+12%" 
            color="primaryBlue"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard 
            icon={<CalendarOutlined style={{ color: theme.successGreen, fontSize: '24px' }} />}
            title="Appointments" 
            value="37" 
            subtitle="Today" 
            trend="+5%" 
            color="successGreen"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard 
            icon={<MedicineBoxOutlined style={{ color: theme.warningOrange, fontSize: '24px' }} />}
            title="Admissions" 
            value="8" 
            subtitle="This week" 
            trend="-3%" 
            trendDown={true} 
            color="warningOrange"
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <StatCard 
            icon={<ClockCircleOutlined style={{ color: theme.purple, fontSize: '24px' }} />}
            title="Avg. Wait Time" 
            value="14 min" 
            trend="-2 min" 
            trendDown={false} 
            color="purple"
          />
        </Col>
      </Row>
      <Card bordered={false} style={{ borderRadius: '8px' }}>
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="Patients" key="1">
            <PatientList patients={patients} />
          </TabPane>
          <TabPane tab="Appointments" key="2">
            <AppointmentList appointments={appointments} />
          </TabPane>
          <TabPane tab="Medical Records" key="3">
            <MedicalRecords />
          </TabPane>
          <TabPane tab="Billing" key="4">
            <Billing />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default Dashboard;